<template>
    <v-app>
        <v-main>
            <router-view/>
        </v-main>
    </v-app>
</template>

<script>
import EventBus from "@/event-bus";

export default {
    name: "App",
    created() {
        (function () {
            var hidden = "hidden";

            // Standards:
            if (hidden in document)
                document.addEventListener("visibilitychange", onchange);
            else if ((hidden = "mozHidden") in document)
                document.addEventListener("mozvisibilitychange", onchange);
            else if ((hidden = "webkitHidden") in document)
                document.addEventListener("webkitvisibilitychange", onchange);
            else if ((hidden = "msHidden") in document)
                document.addEventListener("msvisibilitychange", onchange);
            // IE 9 and lower:
            else if ("onfocusin" in document)
                document.onfocusin = document.onfocusout = onchange;
            // All others:
            else
                window.onpageshow = window.onpagehide
                    = window.onfocus = window.onblur = onchange;

            function onchange(evt) {
                var v = "visible", h = "hidden",
                    evtMap = {
                        focus: v, focusin: v, pageshow: v, blur: h, focusout: h, pagehide: h
                    };

                evt = evt || window.event;
                if (evt.type in evtMap)
                    return
                // console.log(evtMap[evt.type])
                else
                    // console.log(document[hidden]);
                if (!document[hidden]) {
                    EventBus.$emit('ondocumentvisible')
                } else {
                    EventBus.$emit('ondocumenthidden')
                }
            }

            // set the initial state (but only if browser supports the Page Visibility API)
            if (document[hidden] !== undefined)
                onchange({type: document[hidden] ? "blur" : "focus"});
        })();
    }
}
</script>

<style>
.row + .row {
    margin-top: 0;
}

.row.row {
    margin: 0 -12px;
}

.row.row.no-gutters {
    margin: 0;
}

.v-navigation-drawer__content::-webkit-scrollbar {
    width: 5px !important;

}

.v-navigation-drawer__content::-webkit-scrollbar-thumb {
    background: #272727;
    border-radius: 5px;
}

.v-dialog {
    overflow-x: hidden;
    overflow-y: auto;
}

.v-dialog .v-card__text::-webkit-scrollbar {
    width: 5px !important;
}

.v-dialog .v-card__text::-webkit-scrollbar-thumb {
    background: rgba(0, 0, 0, 0.4);
    border-radius: 5px;
}

body, html {
    min-width: 340px;
}

/*Стили для карточек заказов и сборов*/

.v-card.theme--light .darken {
    color: #111111;
}

.v-card.theme--light .darken-light {
    color: #222222;
}

.v-card.theme--light .color-comment {
    color: #0C3D9B;
}

.v-card.theme--light .info-divider {
    border-color: #BDDFFF;
}

.v-card.theme--light .note-input > div > div > fieldset {
    border-color: #BDDFFF;
}

.v-card.theme--dark .darken {
    color: rgba(0, 0, 0, .78);
}

.v-card.theme--dark .color-comment {
    color: #fff;
}

.v-card.theme--dark .darken-light {
    color: rgba(0, 0, 0, .5);
}

.v-card.theme--dark .info-divider {
    color: rgba(0, 0, 0, .3);
}

.v-card.theme--dark .note-input > div > div > fieldset {
    border-color: rgba(0, 0, 0, .3);
}

.v-card.theme--dark .note-input > div > div > .v-text-field__slot > label {
    color: rgba(0, 0, 0, .3);
}

.note-input {
    transform: scale(0.75);
    transform-origin: top left;
    max-width: 133% !important;
    width: 133% !important;
}

.note-input > div > div > fieldset {
    border-width: 2px;
}

.info-bottom {
    font-size: 12px;
    line-height: 14px;
}

.info-text {
    font-size: 14px;
    line-height: 18px;
    white-space: pre-line;
}

.info-comment {
    font-size: 20px;
    line-height: 23px;
    min-width: 135px;
    white-space: pre-line;
}

.info-divider {
    border: none;
    border-top: 1px solid;
    margin: 6px 0;
}

.info-container {
    padding: 8px 11px 14px 11px;
}

.info-rectangle {
    background: rgba(0, 0, 0, 0.05);
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.25);
    padding: 8px 11px;
}

.info-subtitle {
    font-size: 12px;
    line-height: 14px;

    letter-spacing: 0.04em;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.info-title {
    font-weight: bold;
    font-size: 20px;
    line-height: 23px;
    letter-spacing: 0.04em;

    margin-bottom: 2px;
}

.menu-container {
    position: absolute;
    right: 5px;
    top: 5px;
    z-index: 1;
}

.checkbox-container {
    height: 36px;
    width: 36px;
    overflow: visible;
    float: right;
}

.checkbox {
    padding-top: 6px !important;
    padding-left: 5px !important;
}

.btn-menu {
    background-color: rgba(0, 0, 0, .44) !important;
    width: 32px !important;
    height: 32px !important;
}

.card-img-top {
    border-radius: 4px 4px 0 0;
}

@media (max-width: 600px) {
    .card-img-top {
        height: 45vw;
    }
}

@media (min-width: 600px) {
    .card-img-top {
        height: 30vw;
    }
}

@media (min-width: 960px) {
    .card-img-top {
        height: 25vw;
    }
}

@media (min-width: 1264px) {
    .card-img-top {
        height: 15vw;
    }
}

@media (min-width: 1904px) {

}

.count {
    background-color: #f44336 !important;
    color: white;
    padding: 1px 5px;
    margin-right: 2px;
    border-radius: 3px;
}

.v-card {
    border: 1px solid #f2f2f2 !important;
}

/*Фикс бага с растягиванием строк*/
.container.fill-height > .row {
    max-width: initial !important;
}

/*Изменение размера стрелки*/
.size-arrow > div > .v-slide-group__prev {
    min-width: 25px !important;
}

/*Изменение размера стрелки*/
.size-arrow > div > .v-slide-group__next {
    min-width: 25px !important;
}

/*Фикс бага с табами*/
.disable-arrow > div > .v-slide-group__prev {
    display: none !important;
}

/*Фикс бага с табами*/
.disable-arrow > div > .v-slide-group__next {
    display: none !important;
}

/*Добавили шрифт для тостов*/
.toasted-container {
    font-family: Roboto, sans-serif !important;
}

.btn {
    border-color: lightgray;
    border-width: 1px !important;
    border-style: solid !important;
    text-transform: none !important;
    font-weight: 400 !important;
    background-color: #fff !important;
    border-radius: 28px !important;
    -webkit-box-shadow: none !important;
    box-shadow: none !important;
    font-size: .875rem !important;
    letter-spacing: .0178571429em !important;
    line-height: 1.25rem;
}

.btn-h:hover {
    border-color: rgba(0, 0, 0, 0.7);
}

.total-collapse {
    border: none !important;
}

.total-collapse > .v-expansion-panel {
    border: none !important;
    border-radius: 0 !important;
}

.total-collapse > .v-expansion-panel:before {
    display: none !important;
}

.total-collapse > .v-expansion-panel > .v-expansion-panel-header {
    background-color: #f2f2f2;
}

.total-collapse > .v-expansion-panel > .v-expansion-panel-content {
    background-color: #f2f2f2 !important;
}

.fill-divider {
    z-index: 1;
    max-width: 100vw !important;
    width: 100vw !important;
    position: absolute;
    left: 0;
}

.text--dark {
    color: rgba(0, 0, 0, .87) !important;
}

.v-btn.v-btn--fab {
    border-radius: 7px !important;
    border-color: rgba(0, 0, 0, .42) !important;
}

.v-text-field--outlined {
    border-radius: 7px !important;
}

.hide-scrollbar::-webkit-scrollbar {
    display: none;
}

.hide-scrollbar {
    -ms-overflow-style: none;
    scrollbar-width: none;
}
</style>
